import { css } from 'styled-components';
import { getSpacingStyle, SpacingType } from './spacing';

export const set = (topOrAll: SpacingType, right?: SpacingType, bottom?: SpacingType, left?: SpacingType) =>
  css`
    padding: ${getSpacingStyle(topOrAll, right, bottom, left)};
  `;

export const setTop = (top: SpacingType) =>
  css`
    padding-top: ${top};
  `;

export const setBottom = (bottom: SpacingType) =>
  css`
    padding-bottom: ${bottom};
  `;

export const setLeft = (left: SpacingType) =>
  css`
    padding-left: ${left};
  `;

export const setRight = (right: SpacingType) =>
  css`
    padding-right: ${right};
  `;
